<!-- src/apps/secret/reveal/branded/UnknownSecret.vue -->

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import BaseUnknownSecret from '@/shared/components/base/BaseUnknownSecret.vue';
  import type { BrandSettings } from '@/schemas/models/domain/brand';
  import { fontFamilyClasses, FontFamily } from '@/schemas/models/domain/brand';

const { t } = useI18n();

  interface Props {
    brandSettings?: BrandSettings;
    branded?: boolean;
  }

  defineProps<Props>();
</script>

<template>
  <BaseUnknownSecret
    :branded="true"
    :brand-settings="brandSettings">
    <!-- Header with icon and title -->
    <template #header="{ getBackgroundColor }">
      <div class="py-12 text-center">
        <!-- Icon container -->
        <div
          class="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full"
          :style="{ backgroundColor: getBackgroundColor(brandSettings?.primary_color ?? '#dc4a22') }">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-8 w-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 14L12 12M12 12L14 10M12 12L10 10M12 12L14 14M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
          </svg>
        </div>

        <!-- Title -->
        <h1
          class="mb-2 text-2xl font-bold text-gray-900 dark:text-white"
          :class="brandSettings?.font_family
            ? fontFamilyClasses[brandSettings.font_family as FontFamily]
            : ''">
          {{ t('web.secrets.that_information_is_no_longer_available') }}
        </h1>
      </div>
    </template>    <!-- Main message (hidden as we put it in header) -->
    <template #message="{ }">
    </template>

    <!-- Action button -->
    <template #action="{ }">
      <!-- Simple branded button -->
      <router-link
        to="/"
        class="inline-flex items-center justify-center rounded-lg px-6 py-2.5 font-semibold text-white transition-colors hover:opacity-90"
        :style="{
          backgroundColor: brandSettings?.primary_color ?? '#dc4a22',
        }">
        {{ t('web.layout.return_to_home') }}
      </router-link>
    </template>
  </BaseUnknownSecret>
</template>
